import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Base } from './base.jsx';
import type { Props } from './types.js';

/** `<Card>` component. */
export const Card = ({
  children,
  className,
  isErrored,
  isSelected,
  ...props
}: Props): ReactElement => (
  <Base
    className={twMerge(
      'group bg-base-100 transition hover:border-muted',
      isSelected &&
        'cursor-default border-primary bg-primary font-demibold hover:border-primary-highlight hover:bg-primary-highlight',
      isErrored && 'border-error hover:border-2 hover:border-error',
      className
    )}
    {...props}
  >
    {children}
  </Base>
);
